import { Injectable, EventEmitter } from "@angular/core";
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { Observable, of } from 'rxjs';
import {  timeout, catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class ConnectionService {
  // onlineEvent: Observable<Event>;
  // offlineEvent: Observable<Event>;

  // subscriptions: Subscription[] = [];

  connectionStatusMessage: string;
  connectionStatus: string;
  ongetConnectionStatus = new EventEmitter();

  constructor(public http: HttpClient) { }

  getStatus() {
    return this.connectionStatus;
  }

  setStatus(conn: string) {
    this.connectionStatus = conn;
    this.ongetConnectionStatus.emit(this.connectionStatus);
  }


  public getUserList(url: string): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("ftp_access_token"),
      'scac': localStorage.getItem("ftp_user_scac")
    });

    return this.http.get(environment.apiURL + url, {
      headers: headers
    });

  }

  // getConnectionStatus() {
  //   /**
  //    * Get the online/offline status from browser window
  //    */
  //   this.onlineEvent = fromEvent(window, "online");
  //   this.offlineEvent = fromEvent(window, "offline");

  //   this.subscriptions.push(
  //     this.onlineEvent.subscribe(e => {
  //       this.connectionStatusMessage = "Back to online";
  //       this.connectionStatus = "online";
  //       //this.ongetConnectionStatus.emit(this.connectionStatus);
  //     })
  //   );
  //   this.subscriptions.push(
  //     this.offlineEvent.subscribe(e => {
  //       this.connectionStatusMessage =
  //         "Connection lost! You are not connected to internet";
  //       this.connectionStatus = "offline";
  //       //this.ongetConnectionStatus.emit(this.connectionStatus);
  //     })
  //   );
  // }
}
